/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { createSelector } from "@reduxjs/toolkit";
import { organizationApi } from "./api-slice";
import { IManageBaseListResponse, IManageBaseResponse } from '@bvi/api-interfaces/response/manage-base-data';

export const selectOrganization = createSelector(
  (response?: IManageBaseListResponse) => response,
  (response) => (response?.success ? response.payload.data : []),
);

export const selectOrganizationListResult = () =>
  organizationApi.endpoints.getOrganizationList.select();

export const selectOrganizationResponse = (data?: IManageBaseResponse) => {
  if (!data?.success) {
    return [];
  }

  return data.payload.data;
};


